export const DEVICE_UUID_KEY = "@WalletBC:deviceUuid";

const isUuid = (value: string) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    value
  );

/** Stable browser id — generate once, never overwrite localStorage. */
export const getOrCreateDeviceUuid = (): string => {
  try {
    const existing = localStorage.getItem(DEVICE_UUID_KEY)?.trim() || "";
    if (existing) return existing;

    const uuid =
      typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}-web`;

    localStorage.setItem(DEVICE_UUID_KEY, uuid);
    return uuid;
  } catch {
    return `web-${Date.now()}`;
  }
};

export const buildWebDevicePayload = () => {
  const uuid = getOrCreateDeviceUuid();
  return {
    model: "web",
    os:
      typeof navigator !== "undefined"
        ? navigator.userAgent.slice(0, 120)
        : "browser",
    platform: "web",
    device_token: uuid,
    device_type: "browser" as const,
    uuid,
  };
};

export const readJwtClaim = (token: string, claim: string): string | null => {
  if (typeof token !== "string" || !token.includes(".")) return null;
  try {
    const payloadPart = token.split(".")[1];
    if (!payloadPart) return null;
    const normalized = payloadPart.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(
      normalized.length + ((4 - (normalized.length % 4)) % 4),
      "="
    );
    const payload = JSON.parse(atob(padded));
    const value = payload?.[claim];
    return typeof value === "string" && value.trim() ? value.trim() : null;
  } catch {
    return null;
  }
};

export const isStableDeviceUuid = isUuid;
